import { AlertTriangle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { DuplicateEntry } from "./bundleTypes";

export const DuplicateDocumentWarning = ({ otherOccurrences }: { otherOccurrences: DuplicateEntry[] }) => {
  if (otherOccurrences.length === 0) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <AlertTriangle className="h-3.5 w-3.5 text-amber-500 shrink-0" />
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          <p className="font-medium text-xs mb-1">Duplicate document also in:</p>
          <ul className="text-xs space-y-0.5">
            {otherOccurrences.map(entry => (
              <li key={entry.fileId}>&bull; {entry.fileName} in &quot;{entry.groupTitle}&quot;</li>
            ))}
          </ul>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
